import React, { Component } from "react";
// 接口以及调用接口方法
import { queryTicketCost } from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";
// icon
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
// 组件

// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";

@connect((state) => state)
class FinanceMoney extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      param: {
        cityIds: this.props.param.cityIds,
        isMonth: this.props.param.isMonth,
        provinceIds: this.props.param.provinceIds, // 默认 000000全国
        date: this.props.param.date,
        operationProperty: this.props.param.operationProperty,
        operationMode: this.props.param.operationMode,
      },
      queryDate: {
        peopleHour: 0, // 人工工时
        goodMoney: 0, // 物料费用
        workMoney: 0, // 通勤费用
        checkMoney: 0, // 巡检费用
        peopleMoney:0//人工费用
      },
    };
  }

  // 父组件修改param时执行
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.param.provinceIds === this.state.param.provinceIds
      && nextProps.param.isMonth === this.state.param.isMonth
      && nextProps.param.cityIds === this.state.param.cityIds
      && nextProps.param.operationProperty === this.state.param.operationProperty
      && nextProps.param.operationMode === this.state.param.operationMode
      && nextProps.param.date === this.state.param.date
    ) {
      // console.log("一样");
    } else {
      // console.log("不一样");
      this.setState(
        {
          param: {
            cityIds: nextProps.param.cityIds,
            provinceIds: nextProps.param.provinceIds, // 默认 000000全国
            date: nextProps.param.date,
            isMonth: nextProps.param.isMonth,
            operationProperty: nextProps.param.operationProperty,
            operationMode: nextProps.param.operationMode,
          },
        },
        () => {
          // 获取数据
          this.getSuccessRate();
        },
      );
    }
  }

  // 页面加载前获取充电成功率数据
  componentWillMount() {
    this.getSuccessRate();
  }

  // 获取数据
  getSuccessRate() {
    // 获取成功率数据1
    //operationProperty: this.state.param.operationProperty,
    fetchHandler(queryTicketCost, {
      startTime: this.state.param.date,
      cityIds: this.state.param.cityIds,
      operationMode: this.state.param.operationMode,
      
      provinceIds: this.state.param.provinceIds,
      isMonth: this.state.param.isMonth,
    }).then((res) => {
      if (res.data) {
        this.setState({
          queryDate: {
            peopleHour: res.data.peopleHour, // 人工工时
            goodMoney: res.data.goodMoney, // 物料费用
            workMoney: res.data.workMoney, // 通勤费用
            checkMoney: res.data.checkMoney, // 巡检费用
            peopleMoney: res.data.peopleMoney, // 人工费用
          },
        });
        this.props.getSuccessRate(res.data.successRate);
      }
    });
  }

  render() {
    // 总订单环比样式值
    let allClassName = '';
    if (this.state.queryDate.totalOrderChain === 0) {
      allClassName = 'item-rate none';
    } else if (this.state.queryDate.totalOrderChain > 0) {
      allClassName = 'down-out-line item-rate';
    } else {
      allClassName = 'down-up-line item-rate';
    }

    // 成功率环比样式值
    let sucClassName = '';
    if (this.state.queryDate.successRateChain === 0) {
      sucClassName = 'item-rate none';
    } else if (this.state.queryDate.successRateChain > 0) {
      sucClassName = 'down-out-line item-rate';
    } else {
      sucClassName = 'down-up-line item-rate';
    }

    // 成功订单环比样式值
    let sucOrderClassName = '';
    if (this.state.queryDate.successOrderChain === 0) {
      sucOrderClassName = 'item-rate none';
    } else if (this.state.queryDate.successOrderChain > 0) {
      sucOrderClassName = 'down-out-line item-rate';
    } else {
      sucOrderClassName = 'down-up-line item-rate';
    }

    // 失败订单环比样式值
    let failClassName = '';
    if (this.state.queryDate.failureOrderChain === 0) {
      failClassName = 'item-rate none';
    } else if (this.state.queryDate.failureOrderChain > 0) {
      failClassName = 'down-out-line item-rate';
    } else {
      failClassName = 'down-up-line item-rate';
    }
    const content = (
      <div
        className="board-inner"
        style={{ height: "100%", display: "flex", flexDirection: "column" }}
      >
        <div className="order-part pie-part">
          <div className="order-item">
            <div className="item-title">人工工时</div>
            <div className="item-num">{this.state.queryDate.peopleHour}</div>
            
          </div>
          <div className="order-item">
            <div className="item-title">物料费用</div>
            <div className="item-num">{this.state.queryDate.goodMoney}</div>
            
          </div>
          <div className="order-item">
            <div className="item-title">通勤费用</div>
            <div className="item-num">{this.state.queryDate.workMoney}</div>
            
          </div>
          <div className="order-item">
            <div className="item-title">巡检费用</div>
            <div className="item-num">{this.state.queryDate.checkMoney}</div>
           
          </div>
          <div className="order-item">
            <div className="item-title">人工费用</div>
            <div className="item-num">{this.state.queryDate.peopleMoney}</div>
           
          </div>
        </div>
      </div>
    );

    return content;
  }
}

export default injectIntl(FinanceMoney);



// WEBPACK FOOTER //
// ./src/AntD/pages/displayBoard/financeMoney.js